<template>
  <div class="relatevideos-list" v-if="videoList.length">
    <h2>相关视频({{ videoList && videoList.length }})</h2>
    <div class="list">
      <ul>
        <li v-for="(video, index) in videoList" :key="index">
          <div class="headpic" @click="toVideoPage(video.videoId)" :style="'background-image: url(' + fixImgUrl(video.headPic) + ')'"></div>
          <div class="title">{{ video.title }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style lang="less">
  div#app {
    margin-bottom: 0;
  }
</style>
<script>
  import fetchData from '../libs/fetchData'
  import getUA from '@dp/util-m-ua'
  import WhereAmI from '@dp/whereami'
  import cookie from '@dp/cookie'

  const KNB = require('@dp/knb')
  let ua = getUA()

  ;(function () {
    var src = '//cdn.jsdelivr.net/npm/eruda';
    if (!/eruda=true/.test(window.location) && localStorage.getItem('active-eruda') != 'true') return;
    document.write('<scr' + 'ipt src="' + src + '"></scr' + 'ipt>');
    document.write('<scr' + 'ipt>eruda.init();</scr' + 'ipt>');
  })();

  export default {
    name: 'relateVideos',
    props: ['videoId', 'isFromMiniProgram'],
    data () {
      return {
        videoList: [],
        dpid: '',
        appCityId: 0
      }
    },
    created () {
      let vm = this
      vm.configLocation()
      vm.getData()
    },
    computed: {
      'isDPAPP': function () {
        return ua.type == 'dpapp'
      }
    },
    methods: {
      configLocation () {
        WhereAmI.config({
          timeout: 10000,
          enables: [],
          disables: [],
          urlParamNames: [],
          cacheType: "cookie",
          cookieNames: ["locallat", "locallng"],
          storageName: "whereami",
          wxAutoConfig: true,
          city: true,
          cityType: 'dianping',
          source: '',
          sampling: 0.5,
          debug: false
        });
      },
      getData () {
        let vm = this
        let lat = 0
        let lng = 0
        let locateCityId = 0
        WhereAmI(res => {
          if (res.city) {
            locateCityId = res.city.cityid;
          }
          lat = res.lat || 0;
          lng = res.lng || 0;

          if (vm.isDPAPP) {
            KNB.ready(function () {
              let KNBP = KNB.getPromiseInstance()
              KNBP.all([KNBP.getUserInfo(), KNBP.getCity()]).then(res => {
                let user = res[0]
                let city = res[1]
                vm.dpid = user.uuid
                vm.appCityId = city.cityId
                vm.loadData(locateCityId, lat, lng)
              })
            })
          } else {
            vm.loadData(locateCityId, lat, lng)
          }
        }, () => {
          console.log('获取不到cityid');
          if (vm.isDPAPP) {
            KNB.ready(function () {
              let KNBP = KNB.getPromiseInstance()
              KNBP.all([KNBP.getUserInfo(), KNBP.getCity()]).then(res => {
                let user = res[0]
                let city = res[1]
                vm.dpid = user.uuid
                vm.appCityId = city.cityId
                vm.loadData(locateCityId, lat, lng)
              })
            })
          } else {
            vm.loadData(locateCityId, lat, lng)
          }
        });
      },
      loadData (locateCityId, lat, lng) {
        let vm = this
        console.log('videoId', vm.videoId)
        console.log('dpid', vm.dpid)
        console.log('lng', lng)
        console.log('lat', lat)
        console.log('appCityId', vm.appCityId)
        console.log('locateCityId', locateCityId)
        console.log('clientVersion', ua.version)
        console.log('os', ua.os)
        fetchData.getdata({
          urlname: 'getRelateVideoList',
          method: 'post',
          data: {
            videoId: vm.videoId,
            dpid: vm.dpid,
            lng: lng,
            lat: lat,
            appCityId: vm.appCityId,
            locateCityId: locateCityId,
            clientVersion: ua.version,
            os: ua.os
          }
        }).then(res => {
          if (res.code == 200) {
            vm.videoList = res.data
          }
        })
      },
      toVideoPage (videoId) {
        if (this.isFromMiniProgram) {
          if (location.href.indexOf('.51ping.com') > -1) {
            location.href = `https://h5.51ping.com/app/app-video-mobile/index.html?videoId=${videoId}&from=miniProgram`
          } else {
            location.href = `https://h5.dianping.com/app/app-video-mobile/index.html?videoId=${videoId}&from=miniProgram`
          }
          return
        }
        if (ua.type === 'dpapp') {
          location.href = 'dianping://shortvideodetail?isreview=0&videoid=' + videoId;
          return;
        } else {
          cookie('13433_backup', 1, {
            expires: 0,
            path: '/',
            domain: '.dianping.com'
          }) 
          location.href = 'https://evt.dianping.com/synthesislink/13433.html?id=' + videoId + '&vvtype=topic';
        }
      },
      fixImgUrl(url) {
        return url && url.indexOf('http://')!==-1 ? url.replace('http://','https://') : url;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// relateVideos.vue?b734583c